module.exports = __webpack_public_path__ + "media/images/flags/RU-0de9501804d1f1bbdf6823001b9af395.svg";